import React from 'react';

import Container from '../../layout/container/container';

import { StyledTeaserContainerSkeleton } from './teaserContainer.style';

const TeaserContainerSkeleton = () => (
  <StyledTeaserContainerSkeleton>
    <Container>
      <div className="skeleton-wrapper">
        <span />
        <span />
        <span />
      </div>
    </Container>
  </StyledTeaserContainerSkeleton>
);

export default TeaserContainerSkeleton;
